import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import EntranceCellContent from "../components/EntranceCellContent";

function entrance({ width, onResize }: Column.Options) {
	return base(
		ColumnId.Entrance,
		(item) => <EntranceCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default entrance;
